/**
 * Which collapsible sections the compact (agent-monitor rail) task review
 * shows, and whether each starts open. Header + help-request stay outside
 * this list — they are always visible.
 */
export const TASK_REVIEW_RAIL_SECTIONS = [
  'description',
  'input',
  'progress',
  'subtasks',
  'timeline',
  'notes',
] as const;

export type TaskReviewRailSection = (typeof TASK_REVIEW_RAIL_SECTIONS)[number];

export function isRailSectionDefaultOpen(
  section: TaskReviewRailSection,
): boolean {
  return section === 'timeline';
}

export function visibleRailSections({
  hasDescription,
  hasInput,
  hasProgress,
  hasSubtasks,
}: {
  hasDescription: boolean;
  hasInput: boolean;
  hasProgress: boolean;
  hasSubtasks: boolean;
}): TaskReviewRailSection[] {
  const sections: TaskReviewRailSection[] = [];
  if (hasDescription) sections.push('description');
  if (hasInput) sections.push('input');
  if (hasProgress) sections.push('progress');
  if (hasSubtasks) sections.push('subtasks');
  sections.push('timeline', 'notes');
  return sections;
}
